import VerifyEmailForm from '@/components/forms/auth/VerifyEmailForm'
import { Meta } from '@cfs-fixings/shared'

function VerifyEmailPage () {
  return <>
    <Meta title="Complete Signup" />

    <div className="flex justify-center w-full mt-[110px]">
      <VerifyEmailForm />
    </div>
  </>
}

export default VerifyEmailPage
